/* global globalThis */
import errorImg from "../../assets/images/ErrorImg.svg";
import "./ErrorComponent.scss";
import { APP_CONST } from "../../Constants/app.constant";
import { ROUTE_CONST } from "../../Constants/route.constant";
import { handleKeyboardEvent } from "../Helper";

const ErrorComponent = () => {
  const navigateToHome = () => {
    globalThis.location.href = ROUTE_CONST.HOME;
  };
  return (
    <div className="error-comp-wrap">
      <div className="error-comp d-flex justify-center align-center flex-column">
        <img src={errorImg} alt="Error" />
        <button
          type="button"
          className="errorBtn"
          onClick={navigateToHome}
          onKeyDown={(e) => handleKeyboardEvent(e, navigateToHome)}
        >
          {APP_CONST.GOTO_HOME_TEXT}
        </button>
      </div>
    </div>
  );
};

export default ErrorComponent;
